import { useUserRole } from '@ospace/auth'
import { CampaignLayout } from '@ospace/campaign'
import { userTypes } from '@ospace/core-auth'
import { ErrorBoundary } from '@ospace/shared'
import { useParams } from 'react-router-dom'

import { FileManager } from '../components/FileManager'

type FileManagerPageProps = {
  campaignId: number
  isCampaignManager: boolean
}
export const FileManagerPage = (props: FileManagerPageProps) => {
  return (
    <CampaignLayout>
      <FileManager {...props} />
    </CampaignLayout>
  )
}

const Controller = () => {
  const params: any = useParams()
  const campaignId = Number(params?.id)
  const userRole = useUserRole()

  return (
    <FileManagerPage
      campaignId={campaignId}
      isCampaignManager={userRole <= userTypes.CampaignManager}
    />
  )
}

export const FileManagerPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
